import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = ["placeholder", "required"]
const _hoisted_10 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_11 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit User' : 'Add User',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Full Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                placeholder: "Enter full name",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Email Address", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                placeholder: "Enter email address",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Role", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.role) = $event)),
                required: ""
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Select Role", -1),
                _createElementVNode("option", { value: "admin" }, "Admin", -1),
                _createElementVNode("option", { value: "super_admin" }, "Super Admin", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.role]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password) = $event)),
                placeholder: _ctx.isEditing ? 'Leave blank to keep current' : 'Enter password',
                required: !_ctx.isEditing
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.form.password]
              ]),
              (_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Leave blank if you don't want to change the password."))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: "/users",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update User' : 'Create User'), 1)
            ], 8, _hoisted_12)
          ])
        ], 32)
      ])
    ])
  ]))
}